import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { ReactComponent as StarIcon } from '../../../assets/star.svg';

export const HotelRating = ({ rating, ratingCount, size = 'md', variant = 'dark' }: { rating?: number; ratingCount?: number; size?: 'sm' | 'md'; variant?: 'light' | 'dark' }) => {
  return (
    <Flex alignItems={size === 'md' ? 'end' : 'center'} columnGap={1} color={variant === 'light' ? 'white' : 'inherit'}>
      {rating ? (
        <Flex alignItems={'center'} rowGap={'2px'}>
          <StarIcon width={size === 'md' ? '19px' : '16px'} />
          <TextV2 typographyVariant={size === 'sm' ? 'label2' : 'button1'}>{rating}</TextV2>
        </Flex>
      ) : null}
      {ratingCount ? (
        <TextV2 typographyVariant={'label2'} color={variant === 'light' ? 'white' : 'mono12'}>
          ({ratingCount})
        </TextV2>
      ) : null}
    </Flex>
  );
};
